import { progressBarService } from '@/services/progress/progress.service'

/**
 * ProgressBar wrapper
 * var pb = ProgressBar.init("Description", 100, true);
 * ProgressBar.show(pb.getId());
 * pb.inc();
 * pb.close();
 */
class ProgressBarWrapper {
  private id: string
  private instance: any

  constructor(id: string, instance: any) {
    this.id = id
    this.instance = instance
  }

  getId(): string {
    return this.id
  }

  inc(): void {
    progressBarService.inc(this.id)
  }

  close(): void {
    progressBarService.close(this.id)
  }

  isCanceled(): boolean {
    // Get fresh instance to check cancellation status
    const instance = progressBarService.getInstance(this.id)
    return instance?.cancelled || false
  }

  onCancel(callback: () => void): ProgressBarWrapper {
    // Store cancel callback in the instance
    const instance = progressBarService.getInstance(this.id)
    if (instance) {
      instance.onCancel = callback
    }
    return this
  }
}

export const ProgressBar = {
  /**
   * Initialize a progress bar
   * @param description - Progress bar description
   * @param max - Maximum value (-1 for indeterminate)
   * @param cancelable - Whether the progress bar can be cancelled
   */
  init(description: string, max?: number, cancelable?: boolean): ProgressBarWrapper {
    const maxValue = max !== undefined ? max : -1
    const isCancelable = cancelable !== undefined ? cancelable : false

    const instance = progressBarService.init(description, maxValue, isCancelable)
    return new ProgressBarWrapper(instance.id, instance)
  },

  /**
   * Show progress bar by ID
   */
  show(id: string): void {
    progressBarService.show(id)
  },

  /**
   * Get progress bar instance by ID
   */
  get(id: string): ProgressBarWrapper | undefined {
    let instance = id ? progressBarService.getInstance(id) : progressBarService.getLastInstance()
    if (!instance) {
      const visibleInstances = Array.from(progressBarService.instances.values()).filter(
        (entry) => entry.visible && !entry.cancelled
      )
      if (visibleInstances.length === 1) {
        instance = visibleInstances[0]
      }
    }
    if (!instance) return undefined
    return new ProgressBarWrapper(instance.id, instance)
  }
}

export default ProgressBar

